export enum svgS {
  icon = "icon",
  preload = "preload"
}
